module.exports = __webpack_public_path__ + "static/media/a1f05a6515e69ab2886bdaaf1489d410.a1f05a65.ttf";